import vtkSTLReader from './STLReader';
import vtkPLYReader from './PLYReader';
import vtkDracoReader from './DracoReader';
import vtkSTLWriter from './STLWriter';

export default {
  vtkSTLReader,
  vtkPLYReader,
  vtkDracoReader,
  vtkSTLWriter,
};
